import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="w-full bg-[#FAFAF7] text-[#111111] py-20 px-4 sm:px-6" data-id="element-132">
      <div className="max-w-2xl mx-auto" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg prose-stone mx-auto" data-id="element-134">
          <p className="text-2xl font-serif italic text-gray-500 mb-8 border-l-4 border-[#E8652D] pl-4" data-id="element-135">
            Hay un momento que se repite.
          </p>

          <p className="text-lg leading-relaxed mb-6" data-id="element-136">
            Llegas a casa (o terminas de trabajar). Estás cansado. Tienes
            hambre.
          </p>

          <p className="text-lg leading-relaxed mb-6" data-id="element-137">
            Abres la nevera… y tu cerebro empieza a negociar.
          </p>

          <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 my-8 space-y-3" data-id="element-138">
            <p className="text-gray-600 font-medium" data-id="element-139">
              ❌ "Solo hoy pido algo."
            </p>
            <p className="text-gray-600 font-medium" data-id="element-140">
              ❌ "Mañana sí me organizo."
            </p>
            <p className="text-gray-600 font-medium" data-id="element-141">
              ❌ "Total, ya arruiné el día."
            </p>
          </div>

          <p className="text-lg leading-relaxed mb-6 font-semibold" data-id="element-142">
            Y ahí no falla la dieta.
          </p>

          <p className="text-lg leading-relaxed mb-10" data-id="element-143">
            Falla la decisión en el momento de hambre.
          </p>

          <div className="text-center py-8 border-t border-b border-gray-200" data-id="element-144">
            <h2 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-145">
              Meal Prep Turbo no es una dieta.
            </h2>
            <p className="text-xl text-[#E8652D] font-bold" data-id="element-146">
              Es un sistema para que esa decisión deje de existir.
            </p>
          </div>

          <p className="text-lg leading-relaxed mt-10 mb-6" data-id="element-147">
            En 10 minutos planificas tu semana con el método{' '}
            <strong data-id="element-148">3 Bases + 5 Variaciones</strong> (airfryer + cocina).
          </p>

          <p className="text-lg leading-relaxed" data-id="element-149">
            Sin contar calorías. Sin comidas raras. Sin perfeccionismo.
          </p>
        </motion.div>
      </div>
    </section>;
}